import * as React from 'react';
import { TrackersData, ITracker, TRACKER_DATE_FORMAT, conversionForTracker, displayedDailyValue, TRACKER_SRC, IDailyValue } from 'data/TrackersData';
import { Icon } from 'components/widgets/icons';
import { observer } from 'mobx-react';
import { observable, computed } from 'mobx';
import * as moment from 'moment';

import './TrackersStatusWidgets.pcss';
import { UIState, WellnessTabs } from 'data/UIState';
import {PageEnums} from "components/nav/PageEnums";

const TRACKER_WIDTH = 126;
const COUNTDOWN_WIDTH = 126;
const DIVIDER_WIDTH = 48+1+48;

@observer
export class TrackersStatusWidgets extends React.Component<{left?:string, mini:boolean, showCountdown?:boolean}> {

  @computed
  get style() {
    return {
      left:this.props.left?this.props.left:'0px', 
      width:((TrackersData.activeTrackers.length*TRACKER_WIDTH)+(this.props.showCountdown?COUNTDOWN_WIDTH+DIVIDER_WIDTH:0))+'px'
    }
  }

  render() {
    
    const maxTrackers = Math.floor( (UIState.windowWidth - 70 - (this.props.showCountdown?COUNTDOWN_WIDTH+DIVIDER_WIDTH:0)) / TRACKER_WIDTH );
    //console.log('maxTrackers '+maxTrackers);
    let trackers:Array<ITracker> = [];
    if(maxTrackers>=TrackersData.activeTrackers.length) {
      trackers = TrackersData.activeTrackers;
    } else {
      for(let i=0;i<maxTrackers;i++) {
        trackers.push(TrackersData.activeTrackers[i]);
      }
    }
    const trackersContainerStyle = {
      left:this.props.left?this.props.left:'0px', 
      width:((trackers.length*TRACKER_WIDTH)+(this.props.showCountdown?COUNTDOWN_WIDTH+DIVIDER_WIDTH:0))+'px'
    }
    
    return (
      <div className={`trackersStatusWidgets${this.props.mini?' mini':''}${this.props.showCountdown?' countdown':''}`} style={trackersContainerStyle}>
        {this.props.showCountdown && <Countdown /> }
        {trackers.map(tracker=><TrackersStatusWidget key={tracker._id} tracker={tracker} mini={this.props.mini} />)}
      </div>
    );
  }
}

@observer
class TrackersStatusWidget extends React.Component<{tracker:ITracker, mini:boolean}> {

  @observable loaded:boolean = false;
  @observable today:moment.Moment = moment();

  componentDidMount() {
    setTimeout(()=>{ this.loaded = true; },1);
  }

  @computed
  get fitbitSource() {
    return this.props.tracker.isADefaultTracker && this.props.tracker.src===TRACKER_SRC.FITBIT;
  }

  @computed
  get dailyValue() {
    const today:moment.Moment = moment();
    let dailyValue:IDailyValue;
    if(this.fitbitSource) {
      dailyValue = this.props.tracker.dailyValuesFitbit[today.format(TRACKER_DATE_FORMAT)];
    } else {
      dailyValue = this.props.tracker.dailyValues[today.format(TRACKER_DATE_FORMAT)];
    }
    if(!dailyValue) {
      dailyValue = {
        day:today.toDate(),
        src:this.fitbitSource?TRACKER_SRC.FITBIT:TRACKER_SRC.MANUAL,
        value:0
      }
    }    
    return dailyValue;
  }

  @computed
  get percentageIncomplete() {
    return 100-this.percentageComplete;
  }  

  @computed 
  get displayedDailyValue() {    
    return displayedDailyValue(this.props.tracker, this.dailyValue);
  }

  @computed
  get converter() {
    const converter = conversionForTracker(this.props.tracker.id);
    if(converter) {
      return converter;
    } else {
      return (val, reverse?:boolean)=>val;
    }
  }

  @computed  
  get percentageComplete():number {    
    if(this.loaded) {
      const v = this.dailyValue.value;
      if(v) {
        const goal = 1*this.props.tracker.dailyGoal;
        const val = 1*v;
        if(val >= goal) {
          return 100;
        } else {
          return Math.round( (val/goal) * 100 );
        }
      } else {
        return 0;
      } 
    } else {
      return 0;
    }
  }
  render() {    
    return (
      <div className="tracker"
       onClick={()=>{
         UIState.wellnessTab=WellnessTabs.TRACKERS;
         UIState.currentPage = PageEnums.myWellness;
       }}
      >
        <Icon style={this.props.mini?{width:'20px', height:'20px'}:{width:'44px', height:'44px'}} iconName={this.props.tracker.iconName} color={`${this.percentageComplete===100?'#5aed5a':'#7d83b3'}`} />
        <div className="bar"><span style={{width: `${this.percentageComplete}%`}} className={this.percentageComplete===100?'full':''}></span></div>          
        <div className="readout">{this.displayedDailyValue} {this.props.tracker.unit}s</div>
      </div>
    );
  }
}




const Countdown = () =>
  <div></div>
;
